module.exports = __webpack_public_path__ + "img/underwriting_api.be58bd1d.png";